export default {
  ru: {
    '%s %d has already been taken': '{0} "{1}" уже используется в другом навыке',
    '%s are still associated with this entry': '{0} по-прежнему связаны с этой записью',
    '%s cant be blank': '{0} не может быть пустым',
    '%s does not match confirmation': '"{0}" не соответствует подтверждению',
    '%s has already been taken': '"{0}" с таким значением уже существует',
    '%s has already been taken for %d': '{0} с таким значением уже существует для "{1}"',
    '%s Event %d has already been taken for %d': 'Ошибка. Для события "{1}" и "{2}" уже существует автоответ',
    '%s has an invalid entry': '"{0}" имеет недопустимую запись',
    '%s has invalid format': '"{0}" неправильного формата',
    '%s is invalid': '"{0}" недействителен',
    '%s is reserved': '"{0}" зарезервировано',
    '%s ctsuserid is missing': '"{0}" идентификатор отсутствует или неверен',
    '%s is still associated to this entry': '"{0}" по-прежнему связано с этой записью',
    '%s matches one that was used previously': 'Пароль совпадает с одним из предыдущих',
    '%s Max amount of overseers - %d': 'Максимальное количество супервизоров - {0}',
    '%s Max amount of operators - %d': 'Максимальное количество операторов - {0}',
    '%s must be equal to %d': '"{0}" должно быть равно {1}',
    '%s must be greater than %d': '"{0}" должно быть не больше, чем {1}',
    '%s must be greater than or equal to %d': '"{0}" должно быть больше или равно {1}',
    '%s must be less than %d': '"{0}" должно быть меньше, чем {1}',
    '%s must be shorter than %d characters': '"{0}" должно быть короче {1} символов',
    '%s must be less than or equal to %d': '"{0}" должно быть меньше или равно {1}',
    '%s must be true': '"{0}" должно быть истинным',
    '%s should be %d characters': '"{0}" должно быть {1} символа',
    '%s should be at least %d characters': '"{0}" должно быть не менее {1} символов',
    '%s should be at most %d characters': '"{0}" должно быть не более {1} символов',
    '%s should have %d items': '"{0}" должно быть {1} элементов',
    '%s should have at least %d items': '"{0}" должно содержать не менее {1} элементов',
    '%s should have at most %d items': '"{0}" должно быть не более {1} элементов',
    '%s There is %d associated': 'Невозможно удалить потому что есть связанные {0}({1}) ',
    '%s User must be in not ready state and offline': 'Пользователь должен быть в состоянии "Не готов" и "Не в сети" и не иметь открытых активностей',
    'Unable to change the case, it has an open activity': 'Невозможно задать кейс, если в нем есть открытые активности',
    captcha_verification_required: 'Требуется ввод каптчи',
    invalid_capcha_verification: 'Ошибка каптчи',
    invalid_verification_code: 'Неверный код подтверждения',
    max_operators_reached: 'Ошибка лицензии',
    merge_fail: 'Ошибка слияния аккаунтов',
    provider_id_cant_be_blank: 'Не может быть пустым',
    user_logged: 'Пользователь выполнил вход в систему',
    'User logged in': 'Пользователь выполнил вход в систему',
    MISSING_OPERATORS: 'Нет свободных операторов',
    T_A1RT: 'A1RT',
    T_A1RTo_DEFINITION: 'Среднее время отклика на первые запросы клиентов',
    T_AAT_TITLE: 'Среднее время нахождения оператора внутри активности',
    T_ABSENCE_REASON_MESSAGE: 'Причина',
    T_ABSENCE_REASONS: 'Причины отсутствия',
    T_ACCESS_DENIED: 'Доступ запрещен',
    T_ACCOUNT_IS_BLOCKED: 'Учетная запись заблокирована',
    T_ACCOUNT_IS_DISABLED: 'Учетная запись отключена',
    T_ACCOUNTS: 'Учетные записи',
    T_ACCOUNT_ACTIVE: 'Активна',
    T_ACCOUNT_BANNED: 'Забанена',
    T_ACCOUNT_BLOCKED: 'Заблокирована',
    T_ACCOUNT_DISABLED: 'Отключена',
    T_ACCOUNT_STATUS_FULL: 'Статус учетной записи',
    T_ACCOUNT_STATUS: 'Статус УЗ',
    T_ACCS_TITLE: 'Среднее количество параллельных активностей на оператора за период. Средневзвешенное по времени значение',
    T_ACCS: 'ACCS',
    T_ACR_PERCENT_TITLE: 'Процент завершенных оператором активностей от всех активностей',
    T_ACR_RATE: '%ACR',
    T_ACR_TITLE: 'Количество завершенных оператором активностей',
    T_ACR: 'ACR',
    T_ACTIONS: 'Действия',
    T_ACTIVE: 'Активна',
    T_ACTIVITIES_LIMIT: 'Лимит активностей',
    T_ACTIVITIES_NUMBER_IN_QUEUES_TOTAL: 'Активностей\nв очередях всего',
    T_ACTIVITIES_NUMBER_IN_QUEUE: 'Активностей\nв очереди',
    T_ACTIVITIES_MONITORING: 'Мониторинг активностей',
    T_ACTIVITIES: 'Активности',
    T_ACTIVITY_DURATION: 'Длительность активности',
    T_ACTIVITY_ID: 'ID активности',
    T_ACTIVITY_IS_CLOSED_IMPOSSIBLE_TO_ADD_ANSWER_TEMPLATE: 'Активность закрыта. Невозможно добавить шаблон ответа.',
    T_ACTIVITY_NOTIFICATION_ACTIVE_BLOCK: 'Не активен',
    T_ACTIVITY_NOTIFICATION_ACTIVE: 'Активен',
    T_ACTIVITY_NOTIFICATION_CHANNELS: 'Каналы/Типы обращения',
    T_ACTIVITY_NOTIFICATION_FIELDS_HINT: 'В тексте автоответа можно использовать следующие коды полей: ',
    T_ACTIVITY_NOTIFICATION_EVENT: 'Событие',
    T_ACTIVITY_NOTIFICATION_MESSAGE: 'Автоответ',
    T_ACTIVITY_NOTIFICATION_NAME_ERROR: 'Ошибка. Автоответ с таким наименованием уже существует',
    T_ACTIVITY_NOTIFICATION_NAME: 'Наименование',
    T_ACTIVITY_NOTIFICATION_RESULT_TEXT: 'Итоговый текст:',
    T_ACTIVITY_NOTIFICATION_TEXT: 'Текст',
    T_ACTIVITY_NOTIFICATION_UNAUTHORIZED_CUSTOMER: 'По неавторизованным каналам связи вместо данных клиента будут подставляться пустые значения!',
    T_ACTIVITY_NOTIFICATIONS: 'Автоответы',
    T_ACTIVITY_PANEL_SHORTCUT: 'Alt + Shift + A',
    T_ACTIVITY_SEARCH_TEAMS: 'Доступность поиска оператором',
    T_ACTIVITY_STATUS: 'Статус обращения',
    T_ACTIVITY: 'Активность',
    T_ADD_ABSENCE_REASON: 'Добавить причину отсутствия',
    T_ADD_ANSWER_TEMPLATE: 'Добавить шаблон ответа',
    T_ADD_CHANNEL: 'Добавить канал',
    T_ADD_COMMENT: 'Добавить комментарий',
    T_ADD_DEPARTMENT: 'Добавить подразделение',
    T_ADD_DIRECTORY: 'Добавить справочник',
    T_ADD_GROUP: 'Добавить группу',
    T_ADD_INTENT: 'Добавить интент',
    T_ADD_MAGNET: 'Добавить магнит обращений',
    T_ADD_MARKER_ERROR: 'Не удалось добавить маркер',
    T_ADD_MARKER_SHORTCUT: 'Alt + Shift + M',
    T_ADD_MARKER: 'Добавить маркер',
    T_ADD_SKILL: 'Добавить навык',
    T_ADD_SKILLS_DIRECTORY: 'Добавить справочник навыков',
    T_ADD_TEAM: 'Добавить команду',
    T_ADD_UCCE_MRD: 'Добавить MRD',
    T_ADD_USER: 'Добавить пользователя',
    T_ADD: 'Добавить',
    T_ADDED_MARKER_FOR_THEME: 'Добавлен маркер {0} по теме {1}',
    T_AGENT_ID: 'agentId',
    T_AGENT_MESSAGES_COUNT: 'Сообщений оператора',
    T_AGENT_NAME: 'Имя оператора',
    T_AGENT_USERNAME: 'userName',
    T_AGREE: 'Согласен',
    T_AHT_TITLE: 'Среднее время обработки активности операторами',
    T_ALL_ACTIVITIES: 'Все активности',
    T_ALL_CHANNELS: 'Все каналы',
    T_ALL_OPERATORS_ARE_BUSY: 'К сожалению, все операторы не доступны, Вы можете оставить свое сообщение. Оно будет обработано первым доступным оператором.',
    T_ALL_SKILLS: 'Все навыки',
    T_ALL_TEAMS_ACTIVITIES: 'Все активности',
    T_ALL_TEAMS: 'Все команды',
    T_ALL_TYPES: 'Все типы',
    T_ALL: 'Все',
    T_ALLOWED_DOMAINS: 'Допустимые домены адресов внешних подразделений',
    T_ALLOWED_FILE_COUNT_IS: 'Максимальное количество вложений - {0}',
    T_ALLOWED_FILE_SIZE_IS: 'Превышен допустимый размер отправляемых файлов - {0}',
    T_ALLOWED_FILE_SIZE: 'Превышен допустимый размер отправляемых файлов',
    T_ALLOWED_FILE_TYPE_IS: 'Невозможно отправить файл данного типа',
    T_ANSWER_TEMPLATE_THEMES: 'Темы',
    T_ANSWER_TEMPLATE_TEXT: 'Название',
    T_ANSWER_TEMPLATE_VALUE: 'Текст ответа',
    T_ANSWER_TEMPLATES_SEARCH_ERROR: 'Ошибка поиска шаблонов ответов',
    T_ANSWER_TEMPLATES: 'Шаблоны ответов',
    T_ANSWER: 'Ответить',
    T_AR_TITLE: 'Процент активностей, в которых клиент ничего не написал',
    T_AR: '%AR',
    T_ART_TITLE: 'Среднее время отклика на запросы клиентов внутри активности',
    T_ART: 'ART',
    T_ARTO_TITLE: 'Среднее время отклика на первый запрос клиента',
    T_ARTQ_TITLE: 'Среднее время отклика на первый запрос клиента',
    T_ASHT_TITLE: 'Среднее время Чат-сессии',
    T_ASHT: 'ASHT',
    T_ASK_QUESTION: 'Задать вопрос',
    T_AT_LEAST4CHARACTERS: 'Не менее 4 символов',
    T_AT_LEAST8CHARACTERS: 'Не менее 8 символов',
    T_ATT_TITLE: 'Среднее время разговора',
    T_ATTACH_FILE_SHORTCUT: 'Alt + Shift + I',
    T_ATTACH_FILE: 'Прикрепить файл',
    T_ATTACHMENT_NO_SELECTED: 'Файл не выбран',
    T_ATTENTION_UCCE_INTEGRATION_SETTINGS: 'Включена интеграция с КЦ! Настройки не активны!',
    T_ATTENTION_UCCE_INTEGRATION: 'Включена интеграция с КЦ. Настройки маршрутизации CTI Omni не активны',
    T_AUTOCLOSE_CHAT_TIMEOUT: 'Таймаут закрытия, мин',
    T_AUTOCLOSE_MSG_TIMEOUT: 'Таймаут сообщения о закрытии, мин',
    T_AUTOHOLD_CHAT_TIMEOUT: 'Таймаут перевода в ожидание, мин',
    T_AVAILABILITY: 'Доступность',
    T_AVAILABLE_CHANNELS: 'Доступные каналы',
    T_AVAILABLE_SKILLS: 'Доступные навыки',
    T_AVATAR: 'Аватар',
    T_AVERAGE_EVALUATION: 'Средняя оценка',
    T_AVERAGE_FRT: 'A1RTo',
    T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_CHANNEL: 'Средние оценки канала по каждому оператору',
    T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_SKILL: 'Средние оценки оператора по каждому навыку',
    T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_TYPE_REQUEST: 'Средние оценки обращения по каждому оператору',
    T_AVERAGE_RT: 'ART',
    T_BACKEND_VERSION: 'Версия backend',
    T_BACKWARD: 'Назад',
    T_BCR_TITLE: 'Количество активностей, завершенных виртуальным оператором',
    T_BCR_PERCENT_TITLE: 'Доля активностей, завершенных виртуальным оператором, от общего количества завершенных активностей',
    T_BIND_TO_EXISTING_CASE_SHORTCUT: 'Alt + Shift + O',
    T_BIND_TO_EXISTING_CASE: 'Привязать к существующему кейсу',
    T_BIND_TO_NEW_CASE_SHORTCUT: 'Alt + Shift + N',
    T_BIND_TO_NEW_CASE: 'Привязать к новому кейсу',
    T_BIRTHDAY: 'Дата рождения',
    T_BLOCKED: 'Заблокирована',
    T_BROWSER_VERSION: 'Версия браузера',
    T_BY_CHANNEL: 'По каналу',
    T_BY_OPERATOR: 'По оператору',
    T_BY_REQUEST_TYPE: 'По типу обращения',
    T_CALL_ACTIVITIES: 'Очередь активностей',
    T_CALL_HISTORY_SHORTCUT: 'Alt + Shift + H',
    T_CALL_HISTORY: 'История обращений',
    T_CALL_REACT: 'Переход в карточку',
    T_CALL_SEARCH_REACT: 'Поиск клиента',
    T_CANCEL: 'Отмена',
    T_CASE_COMMENT: 'Комментарий к кейсу',
    T_CASE_DESCRIPTION: 'Описание кейса',
    T_CASE_ID: 'ID кейса',
    T_CASES: 'Кейсы',
    T_CCR_PERCENT_TITLE: 'Процент завершенных клиентом активностей от всех активностей',
    T_CCR_RATE: '%CCR',
    T_CCR_TITLE: 'Количество активностей, завершенных клиентом',
    T_CHECKED_AVAILABLE_CHANNELS: 'Выбраны все доступные каналы',
    T_CHANGE_STATUS: 'Сменить статус',
    T_CHANGE: 'Изменить',
    T_CHANGE_WARNING: 'У вас есть несохраненные изменения. Вы уверены, что хотите выйти?',
    T_CHANNEL_CONFIGURATION_IS_EMPTY: 'Конфигурация канала "{0}" пустая',
    T_CHANNEL_CONFIGURATION: 'Конфигурация канала',
    T_CHANNEL_GROUP: 'Группа',
    T_CHANNEL_LIMITS: 'Лимиты обращений по группам каналов',
    T_CHANNEL_LIST: 'Каналы связи',
    T_CHANNEL_NAME: 'Название',
    T_CHANNEL_PROPERTIES: 'Свойства канала',
    T_CHANNEL_SKILL: 'Канал/Навык',
    T_CHANNEL_TYPE: 'Тип канала',
    T_CHANNEL_TYPES: 'Типы каналов',
    T_CHANNEL: 'Канал',
    T_CHANNELS: 'Каналы',
    T_CHAT_WITH_AGENT_COMPLETE: 'Чат с оператором завершен',
    T_CHAT: 'Чат',
    T_CHOOSE: 'Выбрать',
    T_CHOSEN_AGENT: 'Выбран агент',
    T_CHOSEN_CHANNELS_AND_REQUEST_TYPES: 'Выбранные каналы и типы обращений',
    T_CLEAR: 'Очистить',
    T_CLIENT_AWAIT_OPERATOR_CHAT_TITLE: 'Вам ответит первый доступный оператор',
    T_CLIENT_CARD_SHORTCUT: 'Alt + Shift + C',
    T_CLIENT_CARD: 'Карточка клиента',
    T_CLIENT_ID: 'ID клиента',
    T_CLIENT_NAME: 'Имя клиента',
    T_CLIENT: 'Клиент',
    T_CLOSE_ACTIVITY_CANCELED: 'Необходимо проставить маркер',
    T_CLOSE_OPERATOR_ACTIVITY_SHORTCUT: 'Alt + Shift + Q',
    T_CLOSE_OPERATOR_ACTIVITY: 'Закрыть активность',
    T_CLOSE: 'Закрыть',
    T_CLOSED_ACTIVITIES: 'Закрытые активности',
    T_CLOSED_BY_CLIENT: 'Закрыто клиентом',
    T_CLOSED_BY_OPERATOR: 'Закрыто оператором',
    T_CLOSED_BY_SYSTEM: 'Закрыто автоматически',
    T_CLOSED_BY_TIMEOUT: 'Закрыто таймаутом',
    T_CLOSED_TYPE: 'Тип закрытия активности',
    T_CLOSED: 'Закрыт',
    T_CODE: 'Код',
    T_COMMENT_TEXT: 'Текст комментария',
    T_COMMENT: 'Комментарий',
    T_COMMUNICATION_CHANNEL_GROUPS: 'Группы каналов связи',
    T_COMPETENCE: 'Компетенция',
    T_COMPLETE_TIME: 'Время завершения',
    T_CONFIRM_CHANGES: 'Подтвердить изменения?',
    T_CONFIRM_DELETE_CHANNEL: 'Вы точно хотите удалить канал',
    T_CONFIRM_DELETE_INTENT: 'Вы точно хотите удалить интент',
    T_CONFIRM_DELETE_TEAM: 'Вы точно хотите удалить команду',
    T_CONFIRM_DELETE_UCCE_MRD: 'Вы точно хотите удалить MRD',
    T_CONFIRM: 'Подтвердить',
    T_CONNECT_WITH_INTERNET_ERROR: 'Соединение с интернетом отсутствует.',
    T_CONNECT_WITH_INTERNET_SUCCESS: 'Соединение с интернетом восстановлено.',
    T_CONTACT_ADMINISTRATOR: 'Обратитесь к администратору',
    T_CONTACT_CENTRE: 'Контакт-центр нового поколения',
    T_COPIES: 'Копия',
    T_COPY_LINK: 'Копировать ссылку',
    T_COPY_TO_LINK: 'Ссылка  скопирована',
    T_COPY_TO_LINK_ERROR: 'Не удалось скопировать ссылку',
    T_COPY_TO_CLIPBOARD: 'Скопировать в буффер',
    T_CONFIRMATION_CODE: 'Вам отправлен код для сброса пароля по email. Введите код подтверждения:',
    T_CREATE_ACTIVITY: 'Создать активность',
    T_CREATE_OUTGOING_EMAIL_ACTIVITY: 'Создание исходящей email-активности',
    T_CREATE: 'Создать',
    T_CSI_APPLICATION: 'Сценарий CSI',
    T_CSI_TIMEOUT: 'Время отсчета для повторной СSI оценки в часах',
    T_CTI_URL: 'http://www.cti.ru/',
    T_CTS_USER_ID_ERROR: 'Введите верный формат идентификатора',
    T_CUSTOMER_COMMENTARY: 'Комментарий клиента',
    T_CUSTOMER_CONNECTED_HINT: 'Для события "Подключен клиент" можно выбрать канал типа "ВЕБ-ЧАТ" и "ТЕЛЕГРАМ"',
    T_CUSTOMER_IS_TYPING: 'Клиент печатает',
    T_CUSTOMER_MESSAGES_COUNT: 'Сообщений клиента',
    T_CUSTOMER_RATING: 'Оценка клиента',
    T_DATA_ERROR: 'Ошибка. Не удалось получить данные',
    T_DATE_ERROR: 'Неверная дата',
    T_DATE_OF_CREATION: 'Дата создания',
    DATE_TO_SHOULD_NOT_BE_LESS_THAN_DATE_FROM: 'Конец периода не должен быть меньше, чем его начало',
    T_DATE: 'Дата',
    T_DAYS: 'дн.',
    T_DEBUG_INFO_SENT: 'Отладочная информация отправлена',
    T_DEBUG_INFO_DONT_SENDING: 'Отладочная информация не отправлена.',
    T_DEBUG_INFO_NOT_SENT: 'Отладочную информацию не получилось отправить',
    T_DEBUG_INFO_SENDING: 'Отладочная информация отправляется',
    T_DEFAULT_TYPE: 'По умолчанию',
    T_DEFAULT_WELCOME_MESSAGE: 'Здравствуйте! Подскажите, пожалуйста, вас интересует оформление продукта или консультация?',
    T_DELETE_ABSENCE_REASON: 'Удалить причину отсутствия',
    T_DELETE_ANSWER_TEMPLATE: 'Удалить шаблон ответа',
    T_DELETE_MAGNET: 'Удалить магнит',
    T_DELETE_SKILLS_DIRECTORY: 'Удалить справочник навыков',
    T_DELETE_SKILLS_DIRECTORY_TOOLTIP: 'Справочник можно удалить, только удалив из него навыки для перевода',
    T_DELETE_SKILL: 'Удалить навык {0}?',
    T_DELETE_TIMEOUT: 'Вы точно хотите удалить таймаут',
    T_DELETE_USER: 'Удалить пользователя {0}?',
    T_DELETE: 'Удалить',
    T_DEPARTMENT_CATALOG: 'Справочник внешних подразделений',
    T_DEPARTMENT_EMAILS: 'Почтовые ящики',
    T_DEPARTMENT_NAME: 'Название',
    T_DESCRIPTION: 'Описание',
    T_DETAIL_REPORT: 'Отчет по активностям',
    T_DIRECTORIES: 'Справочники',
    T_DIRECTORY_IS_REMOVED: 'Справочник удален',
    T_DIRECTORY_NAME_IS_RESERVED: 'Название справочника "Общий" зарезервировано в системе',
    T_DIRECTORY_PRIORITY: 'Приоритет справочника',
    T_DIRECTORY_SKILLS: 'Навыки справочника',
    T_DIRECTORY: 'Справочник',
    T_DISPLAY_NAME: 'Отображаемое имя',
    T_DOMAIN_MUST_BE_VALID: 'Домены должны быть корректными',
    T_DOMAIN: 'Доменный',
    T_DOMAIN_USER: 'Доменный пользователь',
    T_DOMAINS: 'Введите названия доменов (example.ru, example1.ru)',
    T_DOWNLOAD: 'Скачать',
    T_DOWNLOAD_FAILED_PLEASE_TRY_AGAIN: 'Сбой загрузки, попробуйте снова',
    T_DOWNLOADING_MESSAGES: 'Загрузка сообщений',
    T_DURATION_ACTIVE_NOT_READY: 'Продолжительность "Активен - не готов"',
    T_DURATION_ACTIVE: 'Продолжительность "Активен"',
    T_DURATION_NOT_READY: 'Продолжительность "Не готов"',
    T_DURATION_ONLINE: 'Продолжительность "Онлайн"',
    T_DURATION_READY: 'Продолжительность "Готов"',
    T_DURATION_WAITING: 'Продолжительность ожидания',
    T_DURATION: 'Длительность',
    T_EDIT_ABSENCE_REASON: 'Редактировать причину отсутствия',
    T_EDIT_ACTIVITY_NOTIFICATION: 'Редактировать автоответ',
    T_EDIT_ANSWER_TEMPLATE: 'Редактировать шаблон ответа',
    T_EDIT_CHANNEL: 'Редактировать канал',
    T_EDIT_COMMENT_ON_CUSTOMER: 'Редактировать комментарий',
    T_EDIT_COMMENT: 'Изменить комментарий',
    T_EDIT_DEPARTMENT: 'Редактировать подразделение',
    T_EDIT_DIRECTORY: 'Редактировать справочник',
    T_EDIT_GROUP: 'Редактировать группу',
    T_EDIT_INTENT: 'Редактировать интент',
    T_EDIT_MAGNET: 'Редактировать магнит обращений',
    T_EDIT_MARKER: 'Редактировать маркер',
    T_EDIT_SKILL: 'Редактировать навык',
    T_EDIT_SKILLS_DIRECTORY: 'Редактировать справочник навыков',
    T_EDIT_TEAM: 'Редактировать команду',
    T_EDIT_TIMEOUTS: 'Редактировать таймауты',
    T_EDIT_UCCE_MRD: 'Редактировать MRD',
    T_EDIT_USER: 'Редактировать пользователя',
    T_EDIT: 'Редактировать',
    T_EMAIL_DEPARTMENT: 'E-mail подразделения',
    T_EMAIL_ERROR: 'Заполните поле E-mail',
    T_EMAIL_FROM_KEYBOARD: 'Введите один или несколько E-mail с клавиатуры, разделяя ","',
    T_EMAIL_FROM_LIST: 'Или выберите E-mail из списка',
    T_EMAIL_MUST_BE_UNIQUE: 'Такой E-mail уже используется',
    T_EMAIL_MUST_BE_VALID: 'E-mail должен быть корректным',
    T_EMAIL: 'E-mail',
    T_EMOJI_ACTIVITY: 'Деятельность   ',
    T_EMOJI_CUSTOM: 'Пользовательский',
    T_EMOJI_FOODS: 'Еда и напитки',
    T_EMOJI_NATURE: 'Животные и природа',
    T_EMOJI_NOTFOUND: 'Эмодзи не найден',
    T_EMOJI_OBJECTS: 'Объекты',
    T_EMOJI_PEOPLE: 'Люди и тело',
    T_EMOJI_PLACES: 'Путешествия и места ',
    T_EMOJI_RECENT: 'Часто используемые',
    T_EMOJI_SEARCH_CATEGORIES: 'Результаты поиска',
    T_EMOJI_SEARCH: 'Поиск',
    T_EMOJI_SMILEYS: 'Смайлики и эмоции',
    T_EMOJI_SYMBOLS: 'Символы',
    T_EMPLOYMENT: 'Занятость',
    T_EMPTY_FILTER: 'Сбросить фильтр',
    T_ENCLOSED: 'Закрытые кейсы',
    T_ENT_ADMIN: 'Администратор',
    T_ENTER_COMMENT: 'Дополнительные комментарии',
    T_ENTER_PASSWORD_CONFIRMATION: 'Подтверждение пароля',
    T_ENTER_PASSWORD: 'Пароль',
    T_ENTER_POSITIVE_NUMBER_OR_0: 'Введите целое положительное число или 0',
    T_ENTER_RECEIVED_CODE: 'Введите полученный код',
    T_ENTER_TEXT_HERE: 'Введите текст сообщения',
    T_ENTER_YOUR_NAME: 'Введите имя',
    T_ENTER_YOUR_USER_NAME: 'Логин',
    T_ENTER_PASSWORD_RESET_CONFIRMATION: 'Подтверждение сброса пароля',
    T_ERROR_CHANNEL: 'Нет типов обращения для выбранного канала',
    T_ERROR_LOADING_UCCE_AGENTS: 'Ошибка загрузки агентов UCCE',
    T_ERROR_ON_DELETE_TEAMS: 'Команду невозможно удалить, пока к ней привязаны пользователи (операторы, супервизоры)',
    T_ERROR_TEAM: 'Нет каналов для выбранной команды',
    T_ERROR: 'Ошибка',
    T_ERROR_CREATING_EMAIL_ACTIVITY: 'Ошибка создания email-активности',
    T_ERROR_EXPORT: 'Ошибка экспорта',
    T_ERROR_FILE_FORMAT: 'Ошибка формата файла',
    T_ERROR_LOST_MESSAGES: 'Ошибка при запросе потерянных сообщений:',
    T_ERROR_MUST_BE_GREATER_THAN_0: 'Значение должно быть больше нуля',
    T_ERROR_MUST_NOT_BE_BIGGER_THAN_0: 'Значение не должно быть меньше нуля',
    T_EVENT: 'Событие',
    T_EXIT: 'Выход',
    T_EXPORT_TO_CSV: 'Экспорт в CSV',
    T_EXPORT_OF_CSV_CANCELLED: 'Экспорт отчета в формат CSV отменен пользователем',
    T_EXPORT_WAS_NOT_COMPLETED: 'Экспорт отчета в формат CSV не был выполнен',
    T_EXPRESS_ID_HERE: 'Введите идентификатор',
    T_EXPRESS_ID: 'Идентификатор в Express',
    T_EXPRESS_INTEGRATION: 'Работа в Express',
    T_EXTERNAL_EMPLOYEE: 'Внешний сотрудник',
    T_FCR_PERCENT_TITLE: 'Процент активностей с пометкой клиентом: "Вопрос решен" от всех активностей',
    T_FCR_RATE: '%FCR',
    T_FCR_TITLE: 'Количество активностей с пометкой клиентом: "Вопрос решен"',
    T_FCR: 'FCR',
    T_FEMALE: 'Женский',
    T_FIELD: 'Поле',
    T_FILE_ALREADY_EXISTS: 'Данный файл уже существует',
    T_FILE_DELETE_ERROR: 'Ошибка удаления файла',
    T_FILE_ERROR: 'Файл не найден',
    T_FILE_UPLOADING_ERROR: 'Ошибка загрузки файла',
    T_FINISH_ACTIVITY_MESSAGE: 'Клиент закрыл окно. Можете закрыть активность вручную или дождаться автоматического завершения',
    T_FINISH_ACTIVITY: 'Завершить активность',
    T_FINISH_DAY: 'Закончить смену',
    T_FIRST_NAME: 'Имя',
    T_FIRST_HIT: 'Первое обращение',
    T_FORGOT_RESTORE: 'Восстановить пароль',
    T_FORGOT_YOUR_PASSWORD: 'Забыли пароль?',
    T_FORMAT_NOT_SUPPORTED: 'Формат не поддерживается',
    T_FOUND_ACTIVITIES: 'Найдено активностей',
    T_FROM_WHOM: 'От',
    T_FROM: 'с',
    T_FRONTEND_VERSION: 'Версия фронтенд',
    T_FRT: '1RT',
    T_FULL_HISTORY: 'История пуста',
    T_FULL_NAME_OF_AVAILABLE_OPERATORS: 'ФИО доступных операторов',
    T_FULL_NAME_OF_OPERATOR: 'ФИО оператора',
    T_FULL_NAME: 'Полное имя',
    T_GENDER: 'Пол',
    T_GENERATE_PASSWORD: 'Сгенерировать пароль',
    T_GET_CODE: 'Получить код',
    T_GROUP_ID: 'Группа',
    T_GROUP: 'Группа',
    T_GROUPS_CONFIG: 'Конфигурация группы каналов',
    T_GROUPS: 'Группы',
    T_HACKNEY_OPTS: 'Настройки подключения',
    T_HANGUP: 'Завершить',
    T_HIDE_OPERATOR_ACTIVITY_SHORTCUT: 'Alt + Shift + Q',
    T_HIDE_OPERATOR_ACTIVITY: 'Скрыть активность',
    T_HOME: 'Домашняя Страница',
    T_HOUR: 'час',
    T_IALREADY_USED_THE_CHAT_AND_IHAVE_LOGIN: 'Я уже пользовался чатом и у меня есть логин',
    T_ID: 'ID',
    T_IDENTIFIER: 'Идентификатор',
    T_IN_PROGRESS: 'В работе',
    T_INACTIVE_CHAT_AUTOCLOSE_MSG: 'Сообщение о скором завершении',
    T_INACTIVE_SKILLS_ON_TRANSFER_NOTICE: '* При переводе активности неактивные навыки не отображаются в АРМ оператора и супервизора',
    T_INACTIVE: 'не активно',
    T_INFORMATION: 'Информация',
    T_INSERT_TEXT_FROM_TEMPLATE_SHORTCUT: 'Alt + Shift + P',
    T_INSERT_TEXT_FROM_TEMPLATE: 'Вставить текст из шаблона',
    T_INTEGRATION: 'Интеграция',
    T_INTENT: 'Интент',
    T_INTENTS: 'Интенты чат-бота',
    T_INTEREST_MARKERS: 'Маркеры интересов',
    T_INVALID_PHONE_NUMBER_FORMAT: 'Неверный формат телефона',
    T_IS_ACTIV: 'Активный',
    T_IS_INACTIVE: 'Неактивный',
    T_IS_OFFLINE: 'Не в сети',
    T_IS_SYSTEM: 'Системный',
    T_IS_TYPING: 'печатает',
    T_KEYWORDS_TABLE_HEADER: 'Ключевые слова / фразы',
    T_KEYWORDS: 'Ключевое слово или фраза',
    T_LAST_ACTIVITY_CHANNEL: 'Канал последней активности',
    T_LAST_ACTIVITY_REQUEST_TYPE: 'Тематика последней активности',
    T_LAST_MESSAGE_TIME: 'Время последнего сообщения',
    T_LAST_NAME: 'Фамилия',
    T_LDAP_AUTHORIZATION: 'Авторизация LDAP',
    T_LDAP_USER_REMINDER: 'Поля Логин, E-mail, Имя, Фамилия, Отчество, Статус учетной записи и Роль доменных пользователей задаются администратором Active Directory и не могут быть изменены в АРМ Администратора',
    T_LICENSE: 'Лицензия',
    T_LOAD_MORE: 'Загрузить еще',
    T_LOADING_REPORT_STARTED: 'Загрузка отчета началась, ожидайте',
    T_LOADING: 'Загружаем...',
    T_LOCAL: 'Локальный',
    T_LOG_OUT: 'Вы желаете выйти из системы?',
    T_LOGGED_DURATION: 'Время c последнего входа в систему',
    T_LOGIN_ANONYMOUS: 'Войти как аноним',
    T_LOGIN_CHAT: 'Войти в чат',
    T_LOGIN_ERROR: 'Неправильно введен логин или пароль',
    T_LOGIN_SYSTEM: 'Войти в систему',
    T_LOGIN: 'Логин',
    T_LOGIN_MUST_BE_UNIQUE: 'Логин должен быть уникальным',
    T_LOGIN_MUST_BE_VALID: 'Логин может содержать только латинские буквы, цифры и спецсимволы ( _ - * . , )',
    T_LOST_ACTIVITIES: 'Потерянные активности',
    T_LOST_DEFAULT_STATUS: 'потеряет статус по умолчанию',
    T_MAGNET_TIMEOUT: 'Таймаут магнита, мин',
    T_MAGNET: 'Магнит обращений',
    T_MAGNETS: 'Магниты обращений',
    T_MAIL: 'Почта',
    T_MALE: 'Мужской',
    T_MARKERS_FOR_THEMES: 'Маркеры по теме',
    T_MARKERS_SELECTED: 'Выбранные',
    T_MARKERS: 'Маркеры',
    T_MARKER: 'Маркер',
    T_MAX_254_CHARACTERS: 'Максимум 254 символа',
    T_MAX_COUNT_INPUT_140: 'Максимум 140 символов',
    T_MAX_LENGTH_MSG: 'Максимум {0} символов',
    T_MAX_NUMBER_PREVIOUS_CLIENT_CASES: 'Максимальное количество предыдущих кейсов, отображаемых оператору в чате (от 1 до 20):',
    T_MAX_NUMBER: 'Значение не должно быть больше {0}',
    T_MAX_RT_TITLE: 'Максимальное время ответа внутри активности',
    T_MAX_RT: 'MAX RT',
    T_MAXIMUM_NUMBER_OF_OPERATORS_EXCEEDED: 'Превышено максимальное количество операторов в команде',
    T_MAXIMUM_NUMBER_OF_OVERSEERS_EXCEEDED: 'Превышено максимальное количество супервизоров в команде',
    T_MAX_LENGTH: 'Максимальное количество символов: 50',
    T_MaxRT_DEFINITION: 'Максимальное время ответа внутри активности',
    T_MCCS_TITLE: 'Максимальное количество параллельных активностей на оператора за период. Среднее по максимальным значениям',
    T_MCCS: 'MCCS',
    T_MESSAGE_ERROR: 'Заполните поле сообщения',
    T_MESSAGE_TEXT: 'Текст сообщения',
    T_MESSAGES_FILTER: 'Фильтр сообщений',
    T_MESSAGES: 'Сообщений',
    T_MIDDLE_NAME: 'Отчество',
    T_MIN: 'мин',
    T_MODAL_CHANGE_SKILLS_WITHIN_CHANNELS_HINT: 'Компетенция: уровень владения навыком от 0 до 10.  Чем выше значение, тем выше компетенция.\nВ первую очередь обращения будут поступать на операторов с более высоким уровнем владения навыком.\nДоступность навыков по каналам задается для команды администратором и не может быть изменена',
    T_MODAL_CHANNEL_SKILL_PRIORITY_NOTIFICATION: 'Приоритет: значение от 1 до 100. Чем выше значение, тем выше приоритет типа обращения.\nОбращения с более высоким приоритетом будут обработаны раньше обращений с более низким приоритетом.',
    T_MORE_ACTIVITIES: 'Больше активностей',
    T_MORE_AGENTS: 'Больше агентов Ucce',
    T_MORE_ANSWER_TEMPLATES: 'Больше шаблонов',
    T_MORE_CHANNELS_GROUPS: 'Больше групп каналов',
    T_MORE_CHANNELS: 'Больше каналов',
    T_MORE_DEPARTMENTS: 'Больше подразделений',
    T_MORE_INTENTS: 'Больше интентов',
    T_MORE_MARKERS: 'Больше маркеров',
    T_MORE_MESSAGES: 'Больше сообщений',
    T_MORE_OPERATORS: 'Больше операторов',
    T_MORE_REASONS: 'Больше причин',
    T_MORE_REQUEST_TYPES: 'Больше навыков',
    T_MORE_TEAMS: 'Больше команд',
    T_MORE_USERS: 'Больше пользователей',
    T_MORE_YET: 'ещё',
    T_MORE: 'Больше',
    T_MRD_ID: 'MRD Id',
    T_MRD_NAME: 'MRD Name',
    T_NAME_ALREADY_EXISTS: 'Автоответ с таким названием уже существует',
    T_NAME_CASE: 'Наименование кейса',
    T_NAME: 'Название',
    T_NEW_ACTIVITY_NOTIFICATION: 'Добавить автоответ',
    T_NEW_ACTIVITY: 'У вас новое обращение',
    T_NEW_MESSAGE: 'Новое сообщение',
    T_NEW_MESSAGES: 'Новые сообщения',
    T_NEW_TASK: 'Новый',
    T_NEW_TIMEOUTS: 'Добавить таймауты',
    T_NO_ACTIVITIES_FOR_REPORT: 'Ни одной активности не найдено',
    T_NO_ACTIVITIES: 'Нет активностей',
    T_NO_ANSWER_TEMPLATES: 'Нет шаблонов',
    T_NO_AVAILABLE_CHANNEL_TYPES: 'Нет доступных типов каналов',
    T_NO_AVAILABLE_CHANNELS_OR_SKILLS: 'Нет доступных каналов или навыков',
    T_NO_AVAILABLE_EMAILS: 'Нет доступных электронных адресов',
    T_NO_AVAILABLE_OPERATORS: 'Нет доступных операторов',
    T_NO_AVAILABLE_OVERSEERS: 'Нет доступных супервизоров',
    T_NO_AVAILABLE_REQUEST_TYPES: 'Нет доступных типов обращений',
    T_NO_AVAILABLE_SITES: 'Нет доступных сайтов',
    T_NO_AVAILABLE_TEAMS: 'Нет доступных команд',
    T_NO_AVAILABLE_TEMPLATES_FOR_REQUEST: 'Нет доступных шаблонов по запросу',
    T_NO_AVAILABLE_TEMPLATES: 'Нет доступных шаблонов',
    T_NO_COMMENT: 'Нет комментария',
    T_NO_CASES: 'Кейсы отсутствуют',
    T_NO_DATA_FOR_THIS_PERIOD: 'Нет данных за этот период',
    T_NO_DATA: 'Нет данных',
    T_NO_FREE_OPERATORS: 'Нет свободных операторов',
    T_NO_MARKERS: 'Нет маркеров',
    T_NO_RESULTS: 'По вашему запросу результаты не найдены',
    T_NO_SELECTED_CHANNELS_OR_SKILLS_FOR_CUSTOMIZATION: 'Не выбрано ни одного канала или навыка для настройки',
    T_NO_SKILLS: 'Нет навыков',
    T_NO_TEAM_ASSIGNED: 'Не назначена команда',
    T_NO_THEME: 'Без темы',
    T_NO_THEMES: 'Нет тем',
    T_NO: 'Нет',
    T_NON_SOLVED: 'Вопрос не решен',
    T_NOT_ALL_CHANNELS_SELECTED: 'Выбраны не все каналы для настройки',
    T_NOT_ALL_SKILLS_SELECTED: 'Выбраны не все навыки для настройки',
    T_NOT_FILLED: 'Не заполнено',
    T_NOT_OPEN_CASES: 'У клиента нет открытых кейсов',
    T_NOT_READY_REASON: 'Причина "Не готов -',
    T_NOT_READY_STATUS_DURATION: 'Время в состоянии "Не готов"',
    T_NOT_READY: 'Не готов',
    T_NOT_SENT: 'Не отправлено',
    T_NOTIFICATION_ABOUT_DEFAULT_ACTIVE_VALUE: 'Навык по умолчанию нельзя деактивировать',
    T_NOTIFICATION_ABOUT_SYSTEM_SKILL: 'Системный навык нельзя деактивировать',
    T_NOTIFICATION_ABOUT_DEFAULT_VALUE_WHEN_OBJECT_CREATED: 'Свойство по умолчанию можно выбрать только после его создания',
    T_NOTIFICATION_ABOUT_DESACTIVATE_DEFAULT_VALUE: 'Неактивный элемент нельзя выбрать как элемент по умолчанию, пожалуйста сделайте его активным и сохраните изменения',
    T_NOTIFICATION_ABOUT_SENDING_NEW_PASSWORD: 'Ваш новый пароль отправлен на почту {0}',
    T_NO_RESPONSE_SERVER: 'Ответ от сервера не получен или активность уже закрыта',
    T_NUMBER_OF_HITS: 'Количество обращений',
    T_OF_TEAM: 'команды',
    T_OFF: 'выключена',
    T_OFFLINE: 'Отошел',
    T_CHAT_BOT_APPLICATION: 'Сценарий чат-бота',
    T_OMNI_CENTR: 'Omni center',
    T_ON_HOLD: 'В ожидании',
    T_ON: 'включена',
    T_NOT_AVAILABLE: 'Недоступно',
    T_ONHOLD_OPERATOR_ACTIVITY_SHORTCUT: 'Alt + Shift + W',
    T_ONHOLD_OPERATOR_ACTIVITY: 'Перевести в ожидание',
    T_ONLINE: 'В сети',
    T_ONLINEСONSULTANTСTIOMNI: 'Онлайн консультант CTI OMNI',
    T_OPEN_CASES: 'Открытые кейсы',
    T_OPENED: 'Открыт',
    T_OPERATIONAL_STATISTICS: 'Оперативная статистика',
    T_OPERATOR_ARM: 'АРМ оператора',
    T_OPERATOR_CHANNELS_AND_SKILLS: 'Каналы и навыки оператора',
    T_OPERATOR_IS_TYPING: 'Оператор печатает',
    T_OPERATOR_NAME: 'Имя оператора',
    T_OPERATOR_SKILLS: 'Навыки операторов',
    T_OPERATOR: 'Оператор',
    T_OPERATOR_WITHOUT_TEAM_CANNOT_BE_READY: 'Для перехода в состояние "Готов" оператору должна быть назначена команда',
    T_OPERATORS_LIST: 'Список операторов',
    T_OPERATORS_NOT_READY: 'Операторы в статусе не готов',
    T_OPERATORS_NUMBER_TOTAL: 'Операторов всего',
    T_OPERATORS_NUMBER: 'Операторов',
    T_OPERATORS: 'Операторы',
    T_OUTGOING_EMAIL_ACTIVITY_CREATED: 'Исходящая email-активность создана',
    T_OVERSEER: 'Супервизор',
    T_OVERSEERS: 'Супервизоры',
    T_OK: 'Отправить',
    T_PAGE_NOT_FOUND: 'Страница, которую Вы искали, не существует!',
    T_PAGE_SIZE: 'Количество элементов',
    T_PAIR_ACCOUNT: 'Связать аккаунты',
    T_PASSWORD_CONFIRMATION: 'Подтверждение пароля',
    T_PASSWORD_DIFFICULTY: 'Сложность пароля',
    T_PASSWORD_MUST_BE_VALID: 'Рекомендуется использовать надежные пароли, длиной между 3 и 32 символов и включающие комбинацию прописных и строчных букв, цифр и символов(! $ , . _ - ).',
    T_PASSWORD_NOT_VALID: 'Введенный пароль не удовлетворяет требованиям безопасности.',
    T_PASSWORD_RE_TYPE: 'Повторно введите пароль, чтобы подтвердить его.',
    T_PASSWORD_SETTINGS_LENGTH_ERROR: 'Введите число от 3 до 32.',
    T_PASSWORD_SETTINGS_LENGTH_INFO: 'Минимальное количество символов пароля (от 3 до 32 символов).',
    T_PASSWORD_SETTINGS_LENGTH: 'Минимальная длина пароля',
    T_PASSWORD_SETTINGS_LETTERS_INFO: 'Пароль должен содержать одну или несколько заглавных букв.',
    T_PASSWORD_SETTINGS_LETTERS: 'Заглавные буквы',
    T_PASSWORD_SETTINGS_MINLENGTH_ERROR: 'Длина пароля может быть от {0} символов.',
    T_PASSWORD_SETTINGS_NUMERIC_INFO: 'Пароль должен содержать одну или несколько цифр.',
    T_PASSWORD_SETTINGS_NUMERIC: 'Цифры',
    T_PASSWORD_SETTINGS_SYMBOLS_INFO: 'Пароль должен содержать один или несколько специальных символов.',
    T_PASSWORD_SETTINGS_SYMBOLS: 'Символы',
    T_PASSWORD_SETTINGS_UNIQUENESS_ERROR: 'Количеством предыдущих паролей может быть целым положительным числом.',
    T_PASSWORD_SETTINGS_UNIQUENESS_INFO: 'Пароль не может совпадать с указанным количеством предыдущих паролей.',
    T_PASSWORD_SETTINGS_UNIQUENESS: 'Уникальность',
    T_PASSWORD_SUCCESSFULLY_UPDATED: 'Пароль успешно изменён',
    T_PASSWORD: 'Пароль',
    T_PASSWORDS_DOES_NOT_PATCH: 'Пароли не совпадают.',
    T_PASSWORD_SENT_EMAIL: 'Пароль отправлен на email:',
    T_PENDING_ACTIVITY_TIMEOUT: 'Таймаут нахождения активности в очереди, мин',
    T_PENDING: 'В очереди',
    T_PERIOD_FROM: 'Период от',
    T_PERIOD_TO: 'Период до',
    T_PHONE_NUMBER: 'Номер телефона',
    T_PRIORITY: 'Приоритет',
    T_PROCESSED_ACTIVITIES_COUNT: 'Количество обработанных активностей',
    T_PROCESSED: 'Обработано',
    T_PLEASE_UPLOAD: 'Пожалуйста, загрузите изображение в формате PNG.',
    T_PUT_THE_RATING: 'Для отправки формы необходимо проставить оценки',
    T_QUERY_ACTIVITIES_REPORT: 'Сформировать отчет',
    T_QUESTION_CLOSE_CHAT: 'Вы желаете завершить чат?',
    T_QUESTION: 'Вопрос',
    T_QUEUE_NAME: 'Имя очереди',
    T_QUEUE_REPORT_DATE: 'Дата',
    T_QUEUE_REPORT: 'Отчет по очередям',
    T_QUEUE_TIME: 'В очереди',
    T_RATING: 'Оценка',
    T_RECENT_ACTIVITY_PANEL: 'Панель последних активностей',
    T_READ: 'Прочитано',
    T_READY_STATUS_DURATION: 'Время в состоянии "Готов"',
    T_READY: 'Готов',
    T_REJECTED: 'Потерянные',
    T_RECONNECTED: 'Повторное подключение',
    T_REPEATED: 'Повторное',
    T_REPORT_INFO: '1. Формирование отчета и экспорт\nне являются связанными процессами.\n\n2. Данные в сформированном отчете и экспортированном файле могут отличаться при одинаковых настройках фильтров,\nно разном времени формирования.',
    T_REPORT_ON_EMPLOYMENT_OF_OPERATORS: 'Отчет по занятости операторов',
    T_REQUEST_ERROR: 'Ошибка запроса',
    T_REQUEST_STATUS: 'Статус запроса',
    T_REQUEST_TO_DEPARTMENT_SHORTCUT: 'Alt + Shift + B',
    T_REQUEST_TO_DEPARTMENT: 'Запрос в подразделение',
    T_REQUEST_TYPE: 'Тип обращения',
    T_REQUEST_TYPES_IN_CHANNEL: 'Типы обращений в канале',
    T_REQUEST_TYPES_PRIORITIES: 'Приоритеты навыков',
    T_REQUEST_TYPES: 'Типы обращений',
    T_RESEND: 'Отправить повторно',
    T_RESPONSE_1000: 'Произошла неизвестная ошибка.',
    T_RESPONSE_400: 'Ошибка запроса',
    T_RESPONSE_403: 'Нет доступа к запрашиваемому ресурсу',
    T_RESPONSE_404: 'Запись не найдена',
    T_RESPONSE_422: 'Ошибка формы',
    T_RESPONSE_ACTIVITIES: 'Ошибка при получении текущих активностей:',
    T_RESPONSE_WRONG_LOGIN_OR_PASSWORD: 'Неверный логин или пароль',
    T_RESPONSE_RETRIEVING_LOST_MESSAGES: 'Ошибка при получении потерянных сообщений:',
    T_ROLE: 'Роль',
    T_ROWS_PER_PAGE: 'Строк на странице:',
    T_RTQ_TITLE: 'Время отклика на первый запрос клиента',
    T_SAVE_CHANGES: 'Сохранить изменения?',
    T_SAVE_INFO: 'Сохранить информацию',
    T_SAVE_SKILLS: 'Сохранить навыки',
    T_SAVE: 'Сохранить',
    T_SCRIPT_SELECTOR: 'Script selector',
    T_SECURITY: 'Безопасность',
    T_SEARCH_ACTIVITY_SHORTCUT: 'Alt + Shift + S',
    T_SEARCH_ACTIVITY: 'Поиск активностей',
    T_SEARCH_AGENT: 'Поиск',
    T_SEARCH_AVAILABILITY: 'Доступность поиска активностей оператором',
    T_SEARCH_BY_ACTIVITIES: 'Поиск по активностям',
    T_SEARCH_MODE: 'Режим поиска',
    T_SEARCH_REMINDER: 'Для того, чтобы в форме поиска активностей оператор смог взять обращение в работу, команде должен быть доступен соответствущий канал (доступность навыков по каналу не обязательна)',
    T_SEARCH: 'Искать',
    T_SEARCHING_OPERATOR: 'Подождите, происходит поиск подходящего оператора',
    T_SEC: 'сек',
    T_SELECT_CASE: 'Выберите кейс',
    T_SELECT_DATE_FROM: 'Начало периода',
    T_SELECT_DATE_TO: 'Конец периода',
    T_SELECT_RATING_QUALITY: 'Как вы оцениваете качество полученных ответов?',
    T_SELECT_RATING_SPEED: 'Как быстро вы получили ответы?',
    T_SELECT_RATING: 'Выберите оценку',
    T_SELECT_REQUEST_TYPE_OR_CASE: 'Выберите тип обращения или кейс',
    T_SELECT_REQUEST_TYPE: 'Выберите тип обращения',
    T_SELECT_TEMPLATE: 'Выберите шаблон',
    T_SELECTED_CHANNELS: 'Выбранные каналы',
    T_SELECTED_SKILLS: 'Выбранные навыки',
    T_SELECTED_TEAMS_ACTIVITIES: 'Выбранных команд',
    T_SELECTED_TEAMS: 'Выбранные команды',
    T_SELF_ACTIVITY_TEAMS: 'Активности команды',
    T_SEND_ERROR: 'Не удалось отправить сообщение',
    T_SEND_LINK_TO_BINDING_ACCOUNT: 'Отправить ссылку для связывания аккаунтов',
    T_SEND_OPERATOR: 'Enter - перейти на новую строку, Ctrl+Enter - отправить сообщение',
    T_SEND_USER: 'Enter - отправить сообщение, Ctrl+Enter - перейти на новую строку',
    T_SEND: 'Отправить',
    T_SENT: 'Отправлено',
    T_SET_BY_DEFAULT: 'Задан по умолчанию',
    T_SET_PRIORITIES: 'Настроить приоритеты',
    T_SKILL_ID: 'Id навыка',
    T_SKILL: 'Навык',
    T_SKILLS_AVAILABILITY_IN_CHANNELS: 'Доступность навыков в рамках каналов',
    T_SKILLS_DIRECTORIES: 'Справочники навыков',
    T_SKILLS_WITH_PRIORITY: 'Навыки с приоритетом',
    T_SKILLS: 'Навыки',
    T_SIEBEL_ID: 'Siebel ID',
    T_SIP_URL: 'Адрес SIP',
    T_SIP_PASSWORD: 'Пароль SIP',
    T_SL_TITLE: 'Уровень сервиса',
    T_SL: '%SL',
    T_SOCIAL_NETWORKS: 'Соц. сети',
    T_SOCIAL_PAIR_COMPLETE_VK: 'Ваш аккаунт VK успешно привязан',
    T_SOCIAL_PAIR_FAIL_VK: 'Ваш аккаунт VK не привязан',
    T_SOCIAL_PAIR: 'Привязать аккаунт в социальных сетях',
    T_SOLVED: 'Вопрос решён',
    T_START_CONVERSATION: 'Начать общение',
    T_START_WORK: 'Начать работу',
    T_STATISTICS_SHORTCUT: 'Alt + Shift + D',
    T_STATISTICS: 'Статистика',
    T_STATUS: 'Статус',
    T_SUBMIT_VOTE: 'Отправить отзыв',
    T_SUCCESS: 'Успешно',
    T_SUPERVISOR_ARM: 'АРМ супервизора',
    T_SUPPORT: 'Поддержка',
    T_SURE_WANT_RESET_PASSWORD: 'Вы уверены, что хотите сбросить пароль для:',
    T_SYSTEM_TYPE: 'Системный',
    T_TAKE_IN_WORK_CONFIRMATION: 'Вы точно хотите взять в работу активность по теме',
    T_TASK_ABANDONED: 'Потеряно',
    T_TASK_COMPLETED: 'Завершено',
    T_TASK_RECEIVED: 'Всего активностей',
    T_TASK_START_TIME: 'Начат',
    T_TASK_TYPE: 'Тип',
    T_TEAM_NAME: 'Название',
    T_TEAM_WITH_SKILLS_CAN_NOT_BE_CHANGED: 'Для того, чтобы отредактировать поле "Команда", необходимо удалить все навыки из справочника',
    T_TEAM: 'Команда',
    T_TEAMS: 'Команды',
    T_TELEGRAM_CUSTOMER_CONNECTED_HINT: 'Автоответ в канале ТЕЛЕГРАМ отправляется при первом подключении клиента',
    T_TEMPLATES_CUSTOMER_FIELDS_HINT: 'В тексте шаблона можно использовать следующие коды полей клиента: ',
    T_TEMPLATES_HINT_IS_ACTIVE: 'Подсказка шаблонов активна',
    T_TEMPLATES_HINT_IS_NOT_ACTIVE: 'Подсказка шаблонов не активна',
    T_TEXT_TEMPLATE: 'Текст Шаблона',
    T_THERE_IS_CURRENT_COMBINATION_FOR_ALL: 'Для всех каналов уже настроен автоответ по выбранному событию',
    T_THERE_IS_CURRENT_COMBINATION_TIMEOUT: 'Такая комбинация Команда - Канал - Тип обращения уже существует',
    T_THERE_IS_CURRENT_COMBINATION: 'Для канала уже настроен автоответ по выбранному событию',
    T_TIME_IN_CURRENT_STATUS: 'Время в текущем статусе',
    T_TIME_OUT: 'Таймаут',
    T_TIME_OUT_MESSAGES_REQUEST: 'Таймаут запроса потерянных сообщений',
    T_TIME: 'Время',
    T_TIMEOUTS: 'Таймауты',
    T_TO_QUEUE: 'в очередь',
    T_TO_REGISTER: 'Зарегистрироваться',
    T_TO_TAKE_IN_WORK: 'Взять в работу',
    T_TO_TRANSFER: 'Перевести',
    T_TO_WHOM: 'Кому',
    T_TOCR_PERCENT_TITLE: 'Процент завершенных по таймауту активностей от всех активностей',
    T_TOCR_RATE: '%TOCR',
    T_TOCR_TITLE: 'Количество завершенных по таймауту активностей',
    T_TOCR: 'TOCR',
    T_TOKEN: 'Токен',
    T_TOPIC: 'Тема',
    T_TOPIC_FILL: 'Заполните тему',
    T_ON_TOPIC: 'по теме',
    T_TRANSFER_ERROR: 'Не удалось перевести активность',
    T_TRANSFER_NEW_ACTIVITY: 'У вас новое переведенное обращение',
    T_TRANSFER_OVERSEER: 'Переведено супервизором',
    T_TRANSFER_SHORTCUT: 'Alt + Shift + T',
    T_TRANSFER_TO_ANOTHER_OPERATOR: 'Перевод активности на другого оператора',
    T_TRANSFER_TO_QUEUE: 'Перевод на очередь',
    T_TRANSFER: 'Перевод',
    T_TRANSFERED_TO_OPERATOR: 'Передано оператору',
    T_TRANSFERED_TO_QUEUE: 'Передано в очередь',
    T_TURN_OFF_AUTORIZED_CHANNEL: 'Значения "authorized_channel" и "siebel_no_authorized_channel" не могут быть выбраны одновременно. Параметр "authorized_channel" был выключен.',
    T_TURN_OFF_BUILT_IN_QUALITY_ASSESSMENT: 'Значения "built_in_quality_assessment_enable" и "csi_enable" не могут быть выбраны одновременно. Параметр "built_in_quality_assessment_enable" был выключен.',
    T_TURN_OFF_CSI_ENABLE: 'Значения "built_in_quality_assessment_enable" и "csi_enable" не могут быть выбраны одновременно. Параметр "csi_enable" был выключен.',
    T_TURN_OFF_SIEBEL_AUTORIZED_CHANNEL: 'Значения "authorized_channel" и "siebel_no_authorized_channel" не могут быть выбраны одновременно. Параметр "siebel_authorized_channel" был выключен.',
    T_TYPE: 'Тип',
    T_UCCE_AGENT_IS_BINDED_TO_ANOTHER_USER: 'Агент UCCE привязан к другому пользователю',
    T_UCCE_AGENT: 'Агент UCCE',
    T_UCCE_AGENTS: 'Агенты UCCE',
    T_UCCE_GADGET_VERSION: 'Версия гаджета UCCE',
    T_UCCE_INTEGRATION: 'Интеграция с КЦ',
    T_UCCE_MRD: 'MRD',
    T_UNABLE_TO_DELETE: 'Невозможно удалить.',
    T_UNIQUE_SKILL_DIRECTORY_NAME_HINT: 'Для команды можно добавить справочник только с уникальным названием',
    T_UNITS_DEPARTMENTS: 'Внешние подразделения',
    T_UPDATE_PASSWORD_FORM: 'Изменение пароля',
    T_UPDATING: 'Обновляем...',
    T_URL: 'URL',
    T_USER_NAME: 'Имя пользователя',
    T_USER_ROLE: 'Роль пользователя',
    T_USERS_BINDED: 'Привязаны пользователи',
    T_USERS: 'Пользователи',
    T_USER_NOT_FOUND: 'Пользователь не найден',
    T_UNKNOWN_REPORT_TYPE: 'Тип неизвестен',
    T_UNKNOWN_TEAM: 'Команда неизвестна',
    T_VALIDATE_AUTOCLOSE_CHAT_TIMEOUT: 'Должен быть больше таймаута перевода в ожидание и таймаута сообщения о закрытии',
    T_VALIDATE_AUTOCLOSE_MSG_TIMEOUT: 'Должен быть больше таймаута перевода в ожидание и меньше таймаута закрытия',
    T_VALIDATE_AUTOHOLD_CHAT_TIMEOUT: 'Должен быть меньше таймаута сообщения о закрытии и таймаута закрытия',
    T_VALIDATE_IDENTIFIER: 'Идентификатор может содержать только латинские буквы нижнего регистра, цифры и спецсимволы ( !#$%&\'*+-/=?^_`{|}~@.- ). Максимум 60 знаков.',
    T_VALIDATE_PRIORITY: 'Введите число от 1 до 10',
    T_VALUE_FROM_0_TO_100: 'Введите число от 0 до 100',
    T_VERIFY_CODE: 'Код подтверждения',
    T_VIEW_COMMENT: 'Посмотреть комментарий',
    T_VIP_ACCOUNT: 'VIP аккаунт',
    T_VIRTUAL_OPERATOR: 'Виртуальный оператор',
    T_VOICE_CHANNEL_DISABLE: 'Голосовой канал отключен',
    T_VOICE_CHANNEL_ENABLE: 'Доступен звонок по голосовому каналу',
    T_VOTE_FOR_OPERATOR: 'Оцените работу оператора',
    T_VOTES_RESULTS: 'Результаты опросов',
    T_WAIT_CLIENTS_CONNECT: 'Ожидайте подключение клиентов',
    T_WAIT_EXPORT: 'Дождитесь завершения предыдущего экспорта ({reportType}) в команде ({teamName})',
    T_WARNING: 'Внимание',
    T_WIDGET_NAME: 'Название виджета',
    T_WIDGET_SITE: 'Сайт',
    T_WIDGET: 'Виджет',
    T_WITHOUT_VIRTUAL_OPERATOR: 'Без чат-бота',
    T_WRITE_TO_US_WE_ARE_ONLINE: 'Напишите нам, мы онлайн',
    T_YES_CLOSE_CHAT: 'Да, завершить чат',
    T_YES: 'Да',
    T_YOU_ENTER_AS: 'Вы вошли как',
    T_YOU_LOGGED_IN_ANONYMOUSLY: 'Вы входите в чат анонимно',
    T_YOUR_PHONE_NUMBER: 'Ваш номер телефона',
    T_YOUR_USER_NAME: 'Ваше имя',
    aat: 'Учитывать в AAT',
    abandoned: 'Потеряна',
    account_officer_name: 'Куратор клиента',
    aht: 'Учитывать в AHT',
    att: 'Учитывать в ATT',
    adviser_id: 'Adviser Id',
    adviser_name: 'Adviser Name',
    adviser_first_name: 'Имя',
    adviser_middle_name: 'Отчество',
    adviser_last_name: 'Фамилия',
    branch: 'Регион обслуживания',
    channel_skill: 'Канал/Навык',
    chat: 'Онлайн-чат',
    closed: 'Закрыта',
    customer: 'Клиент',
    city: 'Город',
    dbo_id: 'ID ДБО',
    departament: 'Офис обслуживания',
    directory_name_should_be_unique: 'Для команды можно добавить справочник только с уникальным названием',
    document_type: 'Тип документа',
    document: 'Паспортные данные',
    email: 'Почта',
    facebook: 'Facebook',
    fcc_id: 'FCCid',
    first_name: 'Имя',
    forbidden: 'Действие запрещено',
    in_progress: 'В работе',
    info: 'Информация',
    invalid_code: 'Некорректный код подтверждения',
    invalid_type: 'Пожалуйста, загрузите изображение в формате PNG',
    last_name: 'Фамилия',
    limit_is_exhausted: 'Превышен лимит по количеству одновременно обрабатываемых обращений',
    middle_name: 'Отчество',
    network_error: 'Ошибка сети',
    no_available_operators: 'Нет свободных операторов',
    not_found: 'Команда не найдена',
    on_hold: 'В ожидании',
    operator_not_found: 'Не настроена связь агента с оператором CTI Omni. Обратитесь к администратору.',
    operator: 'Оператор',
    pending: 'В очереди',
    phone: 'Телефон',
    request_type_or_activity_not_found: 'Не найден навык или активность',
    segment: 'Сегмент',
    select_all: 'Все',
    service_package: 'Тарифный план',
    status_was_changed: 'Невозможно взять в работу активность, так как у активности изменился статус',
    team_contains_activities: 'Невозможно удалить, так как есть активности, связанные с командой',
    team_contains_operators_and_overseers: 'Невозможно удалить, так как к команде привязаны операторы и супервизоры',
    team_contains_operators: 'Невозможно удалить, так как к команде привязаны операторы',
    team_contains_overseers: 'Невозможно удалить, так как к команде привязаны супервизоры',
    telegram: 'Telegram',
    transfered: 'Переведена',
    unable_to_logout_active_operator_email: 'Невозможно выйти, так как есть незакрытые или не переведенные в ожидание почтовые обращения',
    unable_to_logout_active_operator_not_email: 'Невозможно выйти, так как есть незакрытые чат-обращения',
    unable_to_logout_active_operator: 'Невозможно выйти, так как есть незакрытые или не переведенные в ожидание обращения',
    unable_to_logout_ready_operator: 'Нельзя выйти готовым оператором',
    unauthorized: 'Не авторизован',
    unexpected_closed: 'Активность закрыта до перевода на другого оператора',
    viber: 'Viber',
    vkontakte: 'Вконтакте',
    whatsapp: 'WhatsApp',
    wrong_format: 'Неверный формат',
    wrong_phone_format: 'Неверный формат телефона',
    CLOSE_ACTIVITY: 'Закрытие обращения',
    CSI_PRE_CLOSE_MSG: 'Скорое завершение пост-опроса',
    CUSTOMER_CONNECTED: 'Подключен клиент',
    NEW_ACTIVITY_AFTER_TRANSFER: 'Новое обращение после перевода',
    NEW_ACTIVITY: 'Новое обращение',
    NO_DATA_AVAILABLE_TEXT: 'Не найдено данных',
    OPERATOR_ASSIGNED: 'Назначен оператор',
    OPERATOR_CONNECTED: 'Оператор подключился',
    TRANSFER_ACTIVITY: 'Ручной перевод обращения',
    authorized_channel: 'Авторизованный канал при интеграции с CRM. Параметр не должен быть включен одновременно с siebel_no_authorized_channel.',
    built_in_quality_assessment_enable: 'Отображение встроенной формы оценки качества обслуживания в веб-чате после завершения диалога.',
    csi_enable: 'Активация функции оценки качества обслуживания с использованием чат-бота.',
    customer_file_transfer_enable_bot: 'Возможность отправки вложений клиентом в диалоге с чат-ботом в веб-чате.',
    customer_file_transfer_enable_operator: 'Возможность отправки вложений клиентом в диалоге с оператором в веб-чате.',
    customer_login_anon_enable: 'Анонимный вход клиента в веб-чат (только указание имени). Должен быть активен customer_login_enabled.',
    customer_login_enabled: 'Необходимость входа клиента в чат (анонимно или по номеру телефона). При неактивном параметре клиент может начать чат сразу после его открытия.',
    customer_login_ident_enable: 'Регистрация и вход клиента в веб-чат по номеру телефона. Должен быть активен customer_login_enabled.',
    enable_auto_classifier: 'Активация автоклассификатора обращения клиента по ключевым словам. При неактивном параметре необходимо выбрать тему обращения или кейс вручную, иначе обращение будет маршрутизировано на навык по умолчанию. Нельзя отключать, если активен virtual_operator_enable.',
    icr_enable: 'Активация отображения блока настроек ICR (Intellectual Call Routing).',
    icr_bot: 'Активация передачи параметров ICR в сценарий чат-бота.',
    icr_routing: 'Активация ICR.',
    operator_file_transfer_enable: 'Возможность отправки вложений оператором.',
    pending_timeout_enable: 'Активация увеличенного таймаута закрытия новых активностей в очереди. Если параметр неактивен, то используется стандартный таймаут deferred_activity_timeout, иначе - увеличенный таймаут pending_activity_timeout.',
    postmessage_authentication_enable: 'Активация получения информации о клиенте из посадочного сайта.',
    send_auto_first_reply: 'Активация автоматической отправки приветствия от оператора клиенту.',
    siebel_no_authorized_channel: 'Неавторизованный канал при интеграции с CRM. Параметр не должен быть включен одновременно с authorized_channel.',
    transfer_to_queue_without_operators: 'Возможность перевода обращения на очередь, в которой отсутствуют доступные операторы.',
    virtual_operator_enable: 'Активация на канале чат-бота, на которого поступают все входящие обращения.',
    choose_request_type: 'Активация выбора типа обращения клиентом вручную при помощи кнопок. Должен быть неактивен enable_auto_classifier.',
    send_auto_warn_reply: 'Активация сообщения об автоматическом завершении активности по таймауту.',
    customer_has_another_activity_on_operator: 'Невозможно создать новую активность. По выбранному каналу открыта другая активность у оператора {0} {1}',
    operator_channel_group_activities_limit_is_reached: 'Превышен лимит активностей. Закройте открытые активности.',
    customer_has_another_pending_activity: 'Невозможно создать новую активность. По выбранному каналу открыта другая активность в очереди.',
    vk_chat_is_removed: 'Невозможно создать новую активность. Клиент удалил чат ВКонтакте.',
    telegram_chat_is_removed: 'Невозможно создать новую активность. Клиент удалил чат в telegram.',
    vk_chat_is_blocked: 'Невозможно создать новую активность. Клиент заблокировал чат ВКонтакте.',
    telegram_chat_is_blocked: 'Невозможно создать новую активность. Клиент заблокировал чат в telegram.',
  },
};
